import type { Props } from "./index.tsx"

export const Home = ({ className, kind }: Props) => {
  if (kind === "outline") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        className={className}
      >
        <path
          fill="currentColor"
          d="M7.725 1.582a.5.5 0 0 1 .629.064l6 6A.5.5 0 0 1 14.5 8v6a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-2.5h-3V14a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V8l.01-.098a.5.5 0 0 1 .136-.256l6-6 .079-.064ZM2.5 8.207V13.5h3V11a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v2.5h3V8.207L8 2.707l-5.5 5.5Z"
        />
      </svg>
    )
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      className={className}
    >
      <path
        fill="currentColor"
        d="M7.725 1.582a.5.5 0 0 1 .629.064l6 6A.5.5 0 0 1 14.5 8v6a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-2.5h-3V14a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V8l.01-.098a.5.5 0 0 1 .136-.256l6-6 .079-.064Z"
      />
    </svg>
  )
}
